// Imported rather than redeclared: this file used to keep its own copy of the
// status union, which then missed 409 when the tender offer-collection verbs
// started returning it.
import type { ApiResponse, Code } from 'fetch';

type AnyResponse = ApiResponse<Code, any>;

type Options<R extends AnyResponse> = {
  [N in Code]?: R extends ApiResponse<N, infer D>
    ? (response: ApiResponse<N, D>) => any
    : never;
} & {
  default?: (response: AnyResponse) => any;
};

export function processResponse<R extends AnyResponse>(
  response: R,
  options: Options<R>
) {
  const handler = options[response.status] || options.default;
  if (typeof handler === 'function') return handler(response as any);
}
